var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heroSection'),_c('speSection'),_c('stepsSection'),_c('proSection'),_c('counterSection'),_c('newSection'),_c('newsLetters'),_c('partenairesSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }